import { useApiQuery } from './useApiQuery';

export interface RegistrationIntensityResponse {
  success: boolean;
  message: string;
  data: {
    heatmap: {
      [date: string]: number;
    };
    totalDays: number;
    totalEngagements: number;
    average: number;
    bestDay: number;
  };
}

export function useRegistrationIntensity(year: number) {
  return useApiQuery<RegistrationIntensityResponse>({
    queryKey: ['registration-intensity', year],
    request: {
      method: 'GET',
      url: `/analytics/engagements/intensity?year=${year}`,
    },
    enabled: !!year,
  });
}
